import React from 'react';
import NameFields from './NameFields';
import EmailField from './EmailField';
import PhoneNumberField from './PhoneNumberField';
import PasswordFields from './PasswordFields';

export default function SignupFields({
  setValue,
  errors,
  register,
  email,
  emailWatch,
}) {
  return (
    <>
      <NameFields register={register} errors={errors} />
      <EmailField
        register={register}
        email={email}
        emailWatch={emailWatch}
        errors={errors}
      />
      <PhoneNumberField
        register={register}
        setValue={setValue}
        errors={errors}
      />
      <PasswordFields register={register} errors={errors} />
    </>
  );
}
